import type { ShowIssueScreenTab } from "models/showIssueScreenModel";

export enum ViewMode {
    createIssue = 'createIssue',
    addToIssue = 'addToIssue',
    relatedIssues = 'viewIssues',
    ribbon = 'ribbon',
    firstLaunch = 'firstLaunch'
}

export enum ModuleView {
    issueView = 'issueView',
    feedView = 'feedView',
}

export const Routes = {
    start: '/start',
    addInstance: '/addInstance',
    basicAuth: '/basicAuth',
    settings: (selectedTab: SettingsScreenTabs) => `/settings/${selectedTab}`,
    createIssue: '/createIssue',
    createIssueSuccess: '/createIssueSuccess',
    addToIssue: '/addToIssue',
    relatedIssues: '/relatedIssues',
    issueChooser: '/issueChooser',
    instanceList: '/instanceList',
    editor: (fieldId: string) => `/editor/${fieldId}`,
    showIssue: (userSystemGuid: string, issueId: string, tabId: ShowIssueScreenTab = "details") => `/showIssue/${userSystemGuid}/${issueId}/${tabId}`,
    logWork: '/logWork',
    firstLaunch: '/firstLaunch'
};

export enum StaticFieldNames {
    instance = 'instance',
    project = 'project',
    issueType = 'issuetype',
    status = 'status',
    issue = 'parent',
    requesttype = 'requesttype',
    comment = 'comment',
    components = 'components',
    description = 'description',
    assignee = 'assignee',
    fixVersions = 'fixVersions',
    priority = 'priority',
    labels = 'labels',
    duedate = 'duedate',
    participants = 'participants',
    reporter = 'reporter',
    summary = 'summary',
    onBehalfOf = 'onBehalfOf',
    attachment = 'attachment',
    originalEstimate = 'originalEstimate',
    remainingEstimate = 'remainingEstimate',
    timeSpent = 'timeSpent',
    timetracking = 'timetracking',
    issueLinks = 'issuelinks',
    worklog = 'worklog'
}

export enum YasoonSetting {
    yasoonLegacyUser = 'user',
    /**Special: should not get overridden - ever */
    license = 'addonLicense', //
    globalState = 'jiraForOutlook',
    /**Special - get/set logic relies on this flag */
    localDataOnly = 'useLocalData',
    /**Special: Version that gets loaded in loader */
    currentVersion = "currentVersion",
    onboarding = "oefj_onboarding",
}

export enum TemplateStringEnum {
    TODAY = '<TODAY>',
    USER = '<USER>',
    SUBJECT = '<SUBJECT>',
    BODY = '<BODY>',
    BODY_PLAIN = '<BODY_PLAIN>',
    SENDER = '<SENDER>',
    SENTAT = '<SENTAT>',
    RECIPIENTS = '<RECIPIENTS>',
    ORGANIZATIONS = '<ORGANIZATIONS>',
}

export enum LocalStorageKey {
    previousState = 'previousState',
    logRocket = 'oefj_logRocket'
}

export enum UiCacheKey {
    projects = 'projects',
    issueTypes = 'issueTypes',
    requestTypes = 'requestTypes'
}

export enum JiraProperties {
    maildata = 'yasoon-outlook-email-data',
    linkedIds = 'yasoon-linked-ids'
}

export enum RelatedIssuesTabId {
    feed = 'feed',
    conversation = 'conversation',
    sender = 'sender',
}

export enum FileUploadType {
    ews = 'ews',
    rest = 'rest',
}

export enum NotificationKey {
    issueCreated = 'issueCreated',
    startupError = 'errorOnStartup',
}

export enum LicenseType {
    office = 'office', //Retrieved via the Office Store
    atlassian = 'atlassian', //Retrieved via Atlassian Marketplace
    yasoon = 'yasoon', // Custom Licenses from yasoon (e.g. old users that got a free license)
}

export enum LicenseFeatures {
    serviceDesk = 'serviceDesk',
    thirdPartyCustomFields = '3rdPartyCustomFields',
    editValues = 'editValues',
}

export enum SettingsScreenTabs {
    appSettings = 0,
    jiraLogin = 1,
}

export enum UpdateChannel {
    default = "default",
    fast = "fast",
}

export enum ServiceDeskParticipantLoadType {
    fromCC = "fromCC",
    fromRecipients = "fromRecipients",
    fromBoth = "fromBoth",
}

export enum EWSValueKeys {
    Id = "Id",
    Name = "Name",
    ContentType = "ContentType",
    ContentId = "ContentId",
    Size = "Size",
    LastModifiedTime = "LastModifiedTime",
    IsInline = "IsInline",
}
